<script lang="ts">
  import PlayerTap from "../Player/PlayerTap.svelte"
  import { playerService } from "../../Services"
  import Sidebar from "./Sidebar.svelte"
  import GameRanking from "../Game/GameRanking.svelte"
  import { getContext } from "svelte"
  import type { State } from "../../Model/State"
  import type { Game } from "../../Model/Game"
  import { derived } from "svelte/store"

  const game: State<Game | undefined> = getContext("game")
  const gameState = derived(game, (game, set) => game?.state.subscribe(set))

  let openSidebar = false

  function toggleSidebar(): void {
    openSidebar = !openSidebar
  }
</script>

<div class="topbar">
  <div class="left">
    <img class="logo" src="/images/logo.png" alt="Fun Box" />
  </div>
  <div class="center">
    <img class="game-name" src="/images/game-name.png" alt="Bin Fun" />
  </div>
  <div class="right">
    {#if $playerService}
      <PlayerTap player={$playerService} on:click={toggleSidebar} />
    {/if}
  </div>
</div>

{#if $gameState === "playing"}
  <Sidebar isOpen={openSidebar} toggle={toggleSidebar}>
    <GameRanking player={$playerService} />
  </Sidebar>
{/if}

<style lang="scss">
  $height: 80px;

  .topbar {
    width: 100%;
    display: flex;
    height: $height;
  }

  .left,
  .right {
    width: $height;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .center {
    flex: 1 1 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .logo {
    width: $height * 0.75;
    height: $height * 0.75;
    object-fit: contain;
  }

  .game-name {
    height: $height * 0.75;
    width: calc(100% - 16px);
    max-width: 250px;
    object-fit: contain;
  }
</style>
